<template>
    <transition name="sf-configuration-toast">
        <div v-if="visible" class="sf__configuration-skipped-toast" role="status">
            <span class="sf__configuration-skipped-toast-icon" aria-hidden="true">i</span>
            <div class="sf__configuration-skipped-toast-content">
                <strong>Configuration skipped automatically</strong>
                <p>This vehicle uses a standard configuration. Fitment and Material steps were skipped.</p>
            </div>
            <button
                type="button"
                class="sf__configuration-skipped-toast-close"
                aria-label="Dismiss"
                @click="dismiss"
            >
                ×
            </button>
        </div>
    </transition>
</template>

<script>
import {CONFIGURATION_SKIPPED_TOAST_KEY} from '../helpers/currentSelection';

export default {
    data() {
        return {
            timer: null,
            visible: false
        };
    },

    mounted() {
        document.addEventListener('seatshop:configuration-skipped', this.show);

        const urlParams = new URLSearchParams(window.location.search);
        const skippedFromUrl = urlParams.get('configuration_skipped') === 'true';

        try {
            if (skippedFromUrl || window.sessionStorage.getItem(CONFIGURATION_SKIPPED_TOAST_KEY) === 'true') {
                this.show();
            }
            window.sessionStorage.removeItem(CONFIGURATION_SKIPPED_TOAST_KEY);
        } catch (error) {}

        if (skippedFromUrl) {
            urlParams.delete('configuration_skipped');
            const query = urlParams.toString();
            window.history.replaceState(null, '', `${window.location.pathname}${query ? `?${query}` : ''}${window.location.hash}`);
        }
    },

    beforeUnmount() {
        document.removeEventListener('seatshop:configuration-skipped', this.show);
        if (this.timer) {
            window.clearTimeout(this.timer);
        }
    },

    methods: {
        show() {
            if (this.timer) {
                window.clearTimeout(this.timer);
            }
            this.visible = true;
            this.timer = window.setTimeout(this.dismiss, 5000);
        },

        dismiss() {
            this.visible = false;
            if (this.timer) {
                window.clearTimeout(this.timer);
                this.timer = null;
            }
        }
    }
};
</script>
